import { render, staticRenderFns } from "./ColumnView.vue?vue&type=template&id=bc9e0682&scoped=true&"
import script from "./ColumnView.vue?vue&type=script&lang=js&"
export * from "./ColumnView.vue?vue&type=script&lang=js&"
import style0 from "./ColumnView.vue?vue&type=style&index=0&id=bc9e0682&lang=scss&scoped=true&"
import style1 from "./ColumnView.vue?vue&type=style&index=1&id=bc9e0682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e0682",
  null
  
)

export default component.exports